/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CommsFieldTemporalLevel {
    Shift = 0,
    Week = 1,
}
